export default "__VITE_ASSET__DY1GWtOw__$_?component__"